import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // If you're using React Router

const useIdleTimer = ({ timeout, onIdle }) => {
    const [isIdle, setIsIdle] = useState(false);
    const navigate = useNavigate(); // For redirecting on logout

    useEffect(() => {
        let idleTimer;
        let lastActive = Date.now();
        const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'click'];

        const resetIdleTimer = () => {
            lastActive = Date.now();
            setIsIdle(false);
            clearTimeout(idleTimer);
            idleTimer = setTimeout(handleIdle, timeout);
        };

        const handleIdle = () => {
            setIsIdle(true);
            onIdle(); // Callback function to perform logout actions
        };

        for (const event of events) {
            window.addEventListener(event, resetIdleTimer);
        }

        idleTimer = setTimeout(handleIdle, timeout);

        return () => {
            clearTimeout(idleTimer);
            for (const event of events) {
                window.removeEventListener(event, resetIdleTimer);
            }
        };
    }, [timeout, onIdle, navigate]);

    return isIdle;
};

export default useIdleTimer;